<template>
    <div id="distributions">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <Filters></Filters>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="distribution in distributions"
                    :key="distribution.identity"
                    :object="distribution"
                    :title="distribution.name ? distribution.name : '-'"
                    :title_link="{name: 'edit_provider_distribution', params: {identity: distribution.identity}}"
                    :sub_title="data_card_sub_title(distribution)"
                    :color="distribution.is_activated ? '' : 'red'"
                    :is_show_column="true"
                    :keys="['priority','strategy','station','material']"
                    :i_18n_key="'distributions'"
                >
                    <span slot="strategy">
                        <span v-if="distribution.strategy == 'direct'">
                            {{ $t('ui.pages.distributions.filter.direct') }}
                        </span>
                        <span v-else-if="distribution.strategy == 'intermodal'">
                            {{ $t('ui.pages.distributions.filter.intermodal') }}
                        </span>
                        <span v-else>
                            {{ distribution.strategy }}
                        </span>
                    </span>
                    <span slot="station">
                        {{ distribution.station ? distribution.station.name : '-'}}
                    </span>
                    <span slot="material">
                        {{ distribution.material ? distribution.material.name : '-'}}
                    </span>
                    <div slot="buttons">
                        <div @click.prevent="delete_distribution(distribution)" class="ui basic red button">
                            {{ $t('ui.general.delete') }}
                        </div>
                    </div>
                </DataCard>

                <div v-if="!is_loading && distributions.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui compact celled table">
                <thead class="center aligned">
                    <tr>
                        <th>{{ $t('models.attributes.distributions.priority') }}</th>
                        <th>{{ $t('models.attributes.distributions.name') }}</th>
                        <th>{{ $t('models.attributes.distributions.strategy') }}</th>
                        <th>{{ $t('models.attributes.distributions.station') }}</th>
                        <th>{{ $t('models.attributes.distributions.material') }}</th>
                        <th>{{ $t('models.attributes.distributions.is_activated') }}</th>
                        <th>{{ $t('ui.general.operate') }}</th>
                    </tr>
                </thead>
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="7">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else class="center aligned">
                    <Distribution v-for="distribution in distributions" :key="distribution.identity" :distribution="distribution">
                    </Distribution>
                    <tr v-if="distributions.length <= 0" class="center aligned">
                        <td colspan="7" >
                            <h5>{{ $t('ui.general.no_data') }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Paginator
                v-if="distributions.length > 0"
                :total_pages="Number(pagination.total_pages)"
                :current_page="Number(pagination.current_page)"
            />
        </div>
    </div>
</template>

<script>
import Filters from "./filter/main.vue"
import DataCard from '@toolbox/data_card/main.vue'
import Distribution from "./index/distribution.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'

export default {
    name: "DistributionsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.distributions_module
        },
        distributions() {
            return this.current_store.distributions
        },
        pagination() {
            return this.current_store.pagination
        },
        filter() {
            return this.current_store.filter
        },
        current_page() {
            return this.current_store.pagination.current_page
        },
        total_pages() {
            return this.current_store.pagination.total_pages
        },
        stations() {
            return this.$store.state.provider.stations
        },
        materials() {
            return this.$store.state.provider.distributions_module.materials
        },
        strategies() {
            return [
                // 站點直派
                {name: this.$t('ui.pages.distributions.filter.direct'), value: "direct"},
                // 轉聯運
                {name: this.$t('ui.pages.distributions.filter.intermodal'), value: "intermodal"},
            ]
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_loading = true
                    resolve()
                })
                await this.$store.dispatch('provider/distributions_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('provider/distributions_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('provider/distributions_module/fetch_distributions')
            } catch (e) {
                switch (e) {
                    default:
                    this.$noty.error("非預期的錯誤: " + e)
                    console.log("非預期的錯誤: ")
                    console.log(e)
                }
            } finally {
                this.is_loading = false
                this.is_initialized = true
            }
        },
        distributions_filter() {
            console.log('distributions_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['provider/distributions_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
        data_card_sub_title(distribution) {
            let result = distribution.is_activated ? 'check' : 'remove'
            return `<i class="${result} icon" style="margin: 0;"></i>`
        },
        delete_distribution(distribution) {
            if (
                confirm(
                    this.$t('ui.notifications.warning.are_you_sure_to_delete_it')
                )
            ) {
                distribution.is_processing = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_distribution_delete).parse(
                    {
                        "distribution_identity": distribution.identity,
                    }
                )
                axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.$noty.success("轄區移除成功")
                        let index = _.findIndex(this.distributions, item => item.identity == distribution.identity)
                        this.distributions.splice(index, 1)
                    } else {
                        this.$noty.error("轄區移除失敗")
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (!error.response) {
                        // Network Error
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data
                        )
                    }
                })
                distribution.is_processing = false
            }
        },
    },
    components: {
        Distribution,
        Paginator,
        ErrorMessages,
        DataCard,
        Filters,
    }
}
</script>
<style scoped lang="scss">
    #distributions {
    }
    .th_dropdown {
        & {
            position: relative;
        }
        span.clear_dropdown {
            position: absolute;
            color: #4c4c4c;
            right: -9px;
            top: -9px;
        }
    }
</style>
